import classNames from "classnames";
import { Pagination, PaginationProps } from "../../atomic/Pagination";
import GenericTable, { TableProps } from "../../atomic/Table/Generic";

interface TableWithPaginationProps extends TableProps<any> {
  pagination: PaginationProps;
  noPaddingX?: boolean;
}

const TableWithPagination = ({
  isLoading = false,
  rows,
  columns,
  pagination,
  onRowClick,
  className,
  styles = {},
  emptyText = "",
  MobileRow,
  visibleColumns = [],
  hasExpandableSection = false,
  expandableContent,
  columnAction,
  wrap,
  noPaddingX = false
}: TableWithPaginationProps) => {
  return (
    <div
      className={classNames(
        "sm:ring-1 ring-gray-200 relative rounded-lg max-w-full overflow-hidden flex flex-col justify-between",
        className
      )}
      style={{
        maxHeight: "70vh" // Need to change this, once tailwind classes are sorted out
      }}
    >
      <GenericTable
        onRowClick={onRowClick}
        styles={styles}
        rows={rows}
        columns={columns}
        emptyText={emptyText}
        MobileRow={MobileRow}
        visibleColumns={visibleColumns}
        pagination={pagination}
        hasExpandableSection={hasExpandableSection}
        isLoading={isLoading}
        columnAction={columnAction}
        expandableContent={expandableContent}
        wrap={wrap}
        noPaddingX={noPaddingX}
      />

      {pagination?.enabled && (
        <Pagination
          total={pagination.total}
          page={pagination.page}
          limit={pagination.limit}
          setPage={pagination.setPage}
          infinite={pagination.infinite}
          paginationMode={pagination.paginationMode}
          dataLength={pagination.dataLength ?? rows?.length ?? 0}
          styles={{
            mobile: "",
            desktop: "lg:flex-none"
          }}
          showOnMobile={pagination.showOnMobile}
        />
      )}
    </div>
  );
};

export default TableWithPagination;
